import { type JSX } from 'react';
import { IconBase, type IconProps } from '@doxyme/icons';

export const Outlook = (props: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 44 44' width={44} height={44} {...props}>
    <g clip-path='url(#clip0_18117_29866)'>
      <path
        d='M44 22.9886C44.0024 22.6445 43.8247 22.3243 43.5314 22.1444H43.5263L43.5078 22.1342L28.2613 13.1091C28.1955 13.0646 28.1272 13.0239 28.0567 12.9873C27.468 12.6836 26.7687 12.6836 26.18 12.9873C26.1095 13.0239 26.0412 13.0646 25.9753 13.1091L10.7289 22.1342L10.7105 22.1444C10.2445 22.4342 10.1016 23.0469 10.3914 23.5128C10.4768 23.6501 10.5944 23.7645 10.734 23.8461L25.9805 32.8712C26.0466 32.9153 26.1149 32.9559 26.1852 32.993C26.7738 33.2967 27.4731 33.2967 28.0618 32.993C28.1321 32.9559 28.2004 32.9153 28.2665 32.8712L43.513 23.8461C43.8176 23.6685 44.0035 23.3412 44 22.9886Z'
        fill='#0A2767'
      />
      <path
        d='M12.5062 16.9627H22.5116V26.1341H12.5062V16.9627ZM41.9535 7.63977V3.44442C41.9775 2.39549 41.1472 1.52538 40.0983 1.50024H14.1342C13.0853 1.52538 12.255 2.39549 12.2791 3.44442V7.63977L27.6279 11.7328L41.9535 7.63977Z'
        fill='#0364B8'
      />
      <path
        d='M12.2791 7.63977H22.5116V16.8491H12.2791V7.63977Z'
        fill='#0078D4'
      />
      <path
        d='M32.7443 7.63977H22.5117V16.8491L32.7443 26.0584H41.9536V16.8491L32.7443 7.63977Z'
        fill='#28A8EA'
      />
      <path
        d='M22.5117 16.8491H32.7443V26.0584H22.5117V16.8491Z'
        fill='#0078D4'
      />
      <path
        d='M22.5117 26.0583H32.7443V35.2676H22.5117V26.0583Z'
        fill='#0364B8'
      />
      <path
        d='M12.5061 26.134H22.5115V34.4715H12.5061V26.134Z'
        fill='#14447D'
      />
      <path
        d='M32.7441 26.0583H41.9534V35.2676H32.7441V26.0583Z'
        fill='#0078D4'
      />
      <path
        d='M43.5314 23.7897L43.512 23.8L28.2655 32.3748C28.199 32.4158 28.1314 32.4546 28.0608 32.4894C27.8019 32.6128 27.5206 32.6824 27.234 32.6941L26.4011 32.207C26.3307 32.1717 26.2624 32.1324 26.1965 32.0893L10.7453 23.2709H10.7381L10.2327 22.9885V40.347C10.2405 41.5052 11.1855 42.4377 12.3436 42.4304H41.9218C41.9392 42.4304 41.9546 42.4222 41.973 42.4222C42.2176 42.4065 42.4588 42.3562 42.6893 42.2728C42.7889 42.2306 42.885 42.1806 42.9768 42.1234C43.0454 42.0845 43.163 41.9996 43.163 41.9996C43.6872 41.6117 43.9975 40.9991 44.0001 40.3471V22.9885C43.9997 23.3205 43.8206 23.6267 43.5314 23.7897Z'
        fill='url(#paint0_linear_18117_29866)'
      />
      <path
        opacity='0.5'
        d='M43.1813 22.9201V23.9843L27.239 34.9607L10.7339 23.2782C10.7339 23.2726 10.7293 23.268 10.7236 23.268L9.20923 22.3573V21.5898L9.83342 21.5796L11.1534 22.3368L11.1841 22.347L11.2966 22.4187C11.2966 22.4187 26.8092 31.2698 26.8501 31.2903L27.4436 31.6382C27.4948 31.6177 27.5459 31.5973 27.6073 31.5768C27.638 31.5563 43.0073 22.9098 43.0073 22.9098L43.1813 22.9201Z'
        fill='#0A2767'
      />
      <path
        d='M43.5314 23.7897L43.512 23.801L28.2655 32.3759C28.1989 32.4168 28.1314 32.4557 28.0608 32.4904C27.4687 32.7797 26.7763 32.7797 26.1841 32.4904C26.114 32.4557 26.0457 32.4175 25.9795 32.3759L10.733 23.801L10.7146 23.7897C10.4203 23.6301 10.2357 23.3234 10.2327 22.9885V40.347C10.24 41.505 11.1846 42.4377 12.3425 42.4304C12.3425 42.4304 12.3426 42.4304 12.3426 42.4304H41.8901C43.0481 42.4378 43.9927 41.505 44.0001 40.3471C44.0001 40.3471 44.0001 40.3471 44.0001 40.347V22.9885C43.9997 23.3205 43.8206 23.6267 43.5314 23.7897Z'
        fill='#1490DF'
      />
      <path
        opacity='0.1'
        d='M28.4874 32.249L28.2592 32.3769C28.193 32.419 28.1247 32.4576 28.0545 32.4926C27.8031 32.616 27.5298 32.6883 27.2502 32.7054L33.0511 39.5653L43.1701 42.0037C43.4473 41.7943 43.6679 41.5188 43.8116 41.2025L28.4874 32.249Z'
        fill='black'
      />
      <path
        opacity='0.05'
        d='M29.5208 31.6678L28.2592 32.377C28.193 32.4191 28.1247 32.4577 28.0545 32.4926C27.8031 32.616 27.5298 32.6883 27.2502 32.7054L29.968 40.1987L43.1731 42.0007C43.6933 41.6101 43.9996 40.9976 43.9999 40.3471V40.123L29.5208 31.6678Z'
        fill='black'
      />
      <path
        d='M12.3713 42.4304H41.8871C42.3412 42.4327 42.7842 42.2892 43.1508 42.0211L26.4001 32.2091C26.3297 32.1738 26.2614 32.1345 26.1954 32.0914L10.7443 23.273H10.7371L10.2327 22.9885V40.2877C10.2315 41.4699 11.189 42.4292 12.3713 42.4304Z'
        fill='#28A8EA'
      />
      <path
        opacity='0.1'
        d='M24.558 11.5619V33.3879C24.5562 34.1532 24.0909 34.841 23.3813 35.1275C23.1614 35.2219 22.9247 35.2707 22.6854 35.2707H10.2324V10.7095H12.2789V9.68628H22.6855C23.7192 9.6902 24.5558 10.5282 24.558 11.5619Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M23.5348 12.5852V34.4112C23.5373 34.6584 23.4849 34.9031 23.3813 35.1275C23.0971 35.8279 22.4181 36.2874 21.6622 36.2909H10.2324V10.7096H21.6622C21.9591 10.7066 22.2517 10.7806 22.5115 10.9245C23.1387 11.2405 23.5345 11.8828 23.5348 12.5852Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M23.5348 12.5852V32.3647C23.5298 33.398 22.6955 34.2355 21.6622 34.2444H10.2324V10.7096H21.6622C21.9591 10.7066 22.2517 10.7806 22.5115 10.9245C23.1387 11.2405 23.5345 11.8828 23.5348 12.5852Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M22.5115 12.5852V32.3647C22.5104 33.3996 21.6738 34.2394 20.6389 34.2444H10.2324V10.7096H20.6389C21.6737 10.7101 22.512 11.5494 22.5115 12.5842C22.5115 12.5845 22.5115 12.5849 22.5115 12.5852Z'
        fill='black'
      />
      <path
        d='M1.87562 10.7096H20.636C21.6719 10.7096 22.5116 11.5494 22.5116 12.5852V31.3456C22.5116 32.3815 21.6719 33.2212 20.636 33.2212H1.87562C0.839734 33.2212 0 32.3814 0 31.3456V12.5852C0 11.5494 0.839758 10.7096 1.87562 10.7096Z'
        fill='url(#paint1_linear_18117_29866)'
      />
      <path
        d='M5.86229 18.5763C6.32457 17.5913 7.07074 16.7671 8.005 16.2095C9.03964 15.6171 10.2177 15.3218 11.4094 15.3561C12.5139 15.3321 13.6038 15.6121 14.56 16.1655C15.459 16.7016 16.1831 17.4872 16.6443 18.4268C17.1467 19.4623 17.397 20.6018 17.375 21.7524C17.3993 22.9549 17.1417 24.1464 16.6229 25.2315C16.1506 26.2047 15.4036 27.0183 14.474 27.5717C13.481 28.142 12.3506 28.4293 11.2058 28.4026C10.0776 28.4298 8.96373 28.1466 7.98556 27.5839C7.07874 27.0471 6.34557 26.2606 5.87356 25.3184C5.36827 24.298 5.11495 23.1713 5.13478 22.0328C5.11373 20.8405 5.36243 19.6589 5.86229 18.5763ZM8.1462 24.1325C8.39267 24.7552 8.81064 25.2952 9.35159 25.6899C9.90259 26.075 10.5624 26.2737 11.2344 26.2568C11.95 26.2851 12.6555 26.0797 13.2441 25.6715C13.7782 25.278 14.1851 24.7365 14.4146 24.1141C14.6712 23.419 14.7978 22.6826 14.7881 21.9417C14.7961 21.1938 14.677 20.4499 14.4361 19.7417C14.2233 19.1024 13.8295 18.5386 13.3024 18.1189C12.7285 17.6914 12.025 17.4746 11.3101 17.5049C10.6235 17.4871 9.94896 17.6874 9.38331 18.0769C8.8332 18.4733 8.4073 19.0181 8.1554 19.6476C7.5966 21.0905 7.59369 22.6896 8.14721 24.1346L8.1462 24.1325Z'
        fill='white'
      />
      <path
        d='M32.7441 7.63977H41.9534V16.8491H32.7441V7.63977Z'
        fill='#50D9FF'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_18117_29866'
        x1='27.1164'
        y1='22.9885'
        x2='27.1164'
        y2='42.4304'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#35B8F1' />
        <stop offset='1' stopColor='#28A8EA' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_18117_29866'
        x1='3.91072'
        y1='9.24402'
        x2='18.6009'
        y2='34.6868'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#1784D9' />
        <stop offset='0.5' stopColor='#107AD5' />
        <stop offset='1' stopColor='#0A63C9' />
      </linearGradient>
      <clipPath id='clip0_18117_29866'>
        <rect
          width='44'
          height='40.9302'
          fill='white'
          transform='translate(0 1.5)'
        />
      </clipPath>
    </defs>
  </IconBase>
);
